import { ReactNode, useEffect } from 'react'
import VideoChat from 'models/VideoChat'
import { DailyProvider } from '@daily-co/daily-react'

type DailyVideoProviderProps = {
  video: VideoChat
  children?: ReactNode
}

const DailyVideoProvider = ({ video, children }: DailyVideoProviderProps) => {
  const callObject = video?.callObject || null

  useEffect(() => {
    if (callObject) {
      return () => {
        video.disconnect()
      }
    }
  }, [callObject, video])

  if (callObject) {
    return <DailyProvider callObject={callObject}>{children}</DailyProvider>
  }

  return <>{children}</>
}

export default DailyVideoProvider
